"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrunkPutRequestSchema = void 0;
const yup_1 = require("yup");
const TrunkPutRequestSchema = (0, yup_1.object)().shape({
    id: (0, yup_1.string)().required(),
    description: (0, yup_1.string)().required().min(3),
    ip: (0, yup_1.string)().required().min(7),
    port: (0, yup_1.number)().required().min(5000).max(9999),
    countryCode: (0, yup_1.string)().required(),
    zone: (0, yup_1.string)().required(),
    callerFormat: (0, yup_1.string)().required(),
    calledFormat: (0, yup_1.string)().required(),
});
exports.TrunkPutRequestSchema = TrunkPutRequestSchema;
